import { fromClassArray, fromClass } from "fw-model";

import { AtsOrganization } from "./ats-organization";
import { AtsOrganizationMapping } from "./ats-organization-mapping";
import { SearchResult } from "./search-result";
import { TransferPlannerRouter } from "./transfer-planner/transfer-planner-router";

export class AtsOrganizationSummary {
    @fromClass Organization: AtsOrganization;
    @fromClass Mapping: AtsOrganizationMapping;
    IntegrationCount: number = 0;
}

export class AtsOrganizationSearchResult extends SearchResult<AtsOrganizationSummary> {}

export class AtsOrganizationTemplateIntegrationResult {
    Id: string;
    TemplateId: string;
    TemplateName: string;
    TemplateVersion: number;
    ProgramCount: number;
    RoleCount: number;
    FormCount: number;
    ReportCount: number;
}

export class CasOrganizationIntegrationResult {
    Id: string;
    CasEnvironment: string;
    CasOrganizationName: string;
    CasFormIdentifier: string;
    CasApplicationFormId: number;
    CasAssociationOrgId: number;
    AtsOrganizationTemplateId: string;
    AtsOrganizationTemplateName: string;
    AtsOrganizationTemplateVersion: number;
    CasProgramCount: number;
    IncludeInProgressApplications: boolean;
    Enabled: boolean;
}

export class CommonAppIntegrationResult {
    Id: string;
    SdsUsername: string;
    SdsPassword: string;
    Enabled: boolean;
    HasMappingExceptions: boolean;
}

export class AtsOrganizationMappingDetail {
    @fromClass Organization: AtsOrganization;
    @fromClass Mapping: AtsOrganizationMapping;
    @fromClass TransferPlannerRouter: TransferPlannerRouter;

    @fromClassArray(AtsOrganizationTemplateIntegrationResult) AtsOrgTemplateIntegrationResults: AtsOrganizationTemplateIntegrationResult[] = [];
    @fromClassArray(CasOrganizationIntegrationResult) CasOrgIntegrationResults: CasOrganizationIntegrationResult[] = [];
    @fromClassArray(CommonAppIntegrationResult) CommonAppIntegrationResults: CommonAppIntegrationResult[] = [];
}

export { AtsOrganization, AtsOrganizationMapping };
